import { render, staticRenderFns } from "./AIcon.vue?vue&type=template&id=7df52b9e"
import script from "./AIcon.vue?vue&type=script&lang=js"
export * from "./AIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports